import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Xspy1 from './img/xspy1.png';
import Zhixingbei from './img/cxcy3.jpg';
import Hjzs1 from './img/hjzs1.jpg';
import Hjzs2 from './img/hjzs2.jpg';
import Hjzs3 from './img/hjzs3.jpg';
import Xkjs4 from './img/xkjs4.jpg';
import Xsjz3 from './img/xsjz3.jpg';
import Zzkt2 from './img/zzkt2.jpg';
import Cxcy3 from './img/cxcy3.jpg';
import './PremiumServe.css';

class Serve extends Component {
    render() {
        // 学生培养项目数据
        const projects = [
            {
                id: 1,
                title: "创新创业",
                image: Cxcy3,
                description: "学生参与各类创新创业项目，培养实践能力和创新思维，通过实际项目锻炼解决复杂工程问题的能力。项目涵盖智能硬件开发、嵌入式系统设计、物联网应用等多个技术领域，全面提升学生的工程实践能力。学生在创新创业方面取得了显著成果，包括："
            },
            {
                id: 2,
                title: "学科竞赛",
                image: Xkjs4,
                description: "学生积极参与各类学科竞赛，在光电设计大赛、全国大学生电子设计竞赛、挑战杯等高水平竞赛中屡获佳绩。通过竞赛实践，学生将理论知识与实际应用相结合，提升了创新能力和解决复杂工程问题的水平。竞赛经历不仅锻炼了学生的专业技能，也培养了团队协作精神和项目管理能力，为未来的职业发展奠定了坚实基础。学生在各类学科竞赛中取得了丰硕成果，包括："
            },
            {
                id: 3,
                title: "学术讲座",
                image: Xsjz3,
                description: "学生积极参与各类学术讲座和学术交流活动，拓宽专业视野，了解前沿技术动态。通过与行业专家和学者的交流，学生能够把握技术发展趋势，提升学术素养和创新能力。其中包括\"智见光影：AI驱动下的照明设计产业新模态\"研讨会以及复旦大学田鹏飞教授基于第三代半导体micro-LED的显示通信传感系统应用讲座："
            },
            {
                id: 4,
                title: "自主课堂",
                image: Zzkt2,
                description: "学生参与自主课堂活动，通过自主学习和团队合作，提升自主学习能力和团队协作精神。在自主课堂中，学生能够充分发挥主观能动性，培养独立思考和解决问题的能力。"
            }
        ];

        return (
            <div className="premium-serve" id="b">
                
                <div className="premium-serve-section">
                    <div className="premium-serve-grid">
                        {projects.map(project => (
                            <Link to={`/student/${project.id}`} key={project.id} className="premium-serve-card">
                                <img className="premium-serve-image" src={project.image} alt={project.title} />
                                <div className="premium-serve-content">
                                    <h3 className="premium-serve-name">{project.title}</h3>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
                
            </div>
        )
    }
}

export default Serve;